import Zendesk from "../../../../contents/docs/cdp/sources/_snippets/source-zendesk.mdx";
import * as React from 'react';
export default {
  Zendesk,
  React
};